<form nestableForm data-testid="xi-4-dataimport-form" class="cnt-column-centered" style="align-items: stretch">

    <div [height]="15"></div>
    <div *ngIf="isShowClose" class="close-cnt cnt-row">
        <div class="filler"></div><close-btn (click)="onClose()"></close-btn><div [width]="10"></div>
    </div>
    <div [height]="15"></div>
    <div class="cnt-column-centered">
        <div class="h1Font text-center" i18n>{{ 'COMPONENT_ASSOCIATIONS' | translate }}</div>
        <div style="height: 20px;"></div>
        <div class="p1Font text-center" i18n>{{ 'PLAN_CONSIST_OF' | translate }}<b>{{ 'COMPONENTS' | translate }}</b> {{ 'THAT_REPRESENT_YOUR_REAL' | translate }} <b>{{ 'COMPONENT' | translate }}</b> {{ 'IS_MATCHED_TO_A' | translate }}</div>
        <div class="cnt-row-centered"><div class="p1Font" i18n>{{ 'RELEVANT_XERO_ACCOUNT_IN' | translate }} <b>{{ 'COMPONENT' | translate }}</b> {{ 'WILL_HAVE_MULTIPLE_RELEVANT' | translate }}</div></div>
        <div style="height: 20px;"></div>
        <div class="cnt-row-centered"><div class="p1Font" i18n>{{ 'FOR_EXAMPLE_AN' | translate }} <b>{{ 'ASSET_COMPONENT' | translate }}</b> {{ 'WILL_HAVE_ACCOUNTS_THAT' | translate }}</div></div>
        <div style="height: 20px;"></div>
        <div class="cnt-row-centered"><div class="p1Font" i18n>{{ 'USE_THIS_SCREEN_TO' | translate }}</div></div>
        <div style="height: 20px;"></div>
    </div>

    <div style="height: 20px;"></div>

    <div *ngFor="let item of ca | keyvalue: sortAccNull">
        <div *ngIf="!((item.value | json) == '{}') && !(getWorkMode() && item.key === 'Employee components' && !isXeroEmployee)" class="pane">

            <div *ngIf="objectKeys(item.value).length > 0" [height]="5"></div>
            <scrolldiv #scroll *ngIf="objectKeys(item.value).length > 0" style="width: 100%;" [scrollerSize]="20" [navigatorSize]="14" [scrollVerticalIndent]="0" cls="lightScroll">
                <div>
                    <div class="cnt-row">
                        <div class="h3font accountTitle nowrap b1color"
                             [style.min-width.px]="leftTitleMaxWidth + 135"
                             attr.data-testid="accountTitle-{{item.key}}">
                            {{item.key}}
                        </div>
                        <div *ngFor="let title of columnTitlesMap.get(item.key)" class="h3font nowrap b1Color" [style.min-width.px]="getHeaderWidth(title)">
                            {{title}}
                        </div>
                    </div>
                    <div [height]="10"></div>
                    <div class="line g4background"></div>
                <div *ngFor="let item1 of item.value | keyvalue: sortAccSubNull; let i = index;">
                    <div [height]="10"></div>
                    <div class="cnt-row-centered">

                        <div class="icon-cls {{getIcon(item)}}"></div>

                        <div *ngIf="!getWorkMode()" class="p2Font nowrap" [style.min-width.px]="leftTitleMaxWidth + 80">{{curtailAccount(accountsMap.get(item1.key) ?? '')}}</div>
                        <div *ngIf="getWorkMode()" class="p2Font nowrap" [style.min-width.px]="leftTitleMaxWidth + 80">{{curtailAccount(extractComponentName(item1.key))}}</div>

                        <xeroLinks #xeroLink name="{{item1.key}}_xeroLink"
                                   [ngModel]="item1.value"
                                   [xeroAccounts]="xeroAccounts"
                                   [xeroFilters]="xeroLinkHeadingFiltersList"
                                   [linkSizes]="getTitleSizes(item.key)"
                                   [parentName]="'default'"
                                   [showInfoPopup]="false"
                                   [showLabel]="false"
                                   (change)="onXeroLinkChange()"
                                   (click)="activateLink(item1.value)">
                        </xeroLinks>
                    </div>

                    <div *ngIf="i == objectKeys(item.value).length - 1" [height]="5"></div>

                </div>

                    <div *ngIf="scroll && scroll.isHorizontalScroll()" [height]="20"></div>
                </div>
            </scrolldiv>
        </div>
        <div style="height: 15px;"></div>
    </div>

</form>
    <div class="loadingio-spinner-rolling-vo35qopy25" style="display: none">
        <div class="ldio-ty68crv3j7">
            <div></div>
        </div>
    </div>
